import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { CollectionsLayoutComponent } from "./collections.layout";
import { CollectionsComponent } from "./collections.component";
import { RecentTransactionComponent } from "./recent-transaction/recent-transaction.component";

export const routes: Routes = [
    {
        path: "",
        component: CollectionsLayoutComponent,

        children: [
            {
                path: "",
                component: CollectionsComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class CollectionsRoutingModule {}
